/*
 * ohsilk Free-Gift ab Schwellenwert
 * Legt das ESSENTIAL Scrunchie Set automatisch in den Warenkorb, sobald der
 * Warenkorbwert (ohne Geschenk) die Schwelle erreicht, und entfernt es wieder,
 * wenn der Wert darunter faellt. Der Preis wird ueber einen automatischen
 * Shopify-Rabatt (100 % auf das Set) auf 0 gesetzt.
 */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 57387133370713; // Hyatec Silk Scrunchie Set Essential
  var THRESHOLD_CENTS = 9900;           // 99,00 EUR
  var GIFT_PROP = '_gift';              // markiert das Geschenk-Line-Item

  var running = false;
  var queued = false;

  function isGiftLine(item) {
    return item.id === GIFT_VARIANT_ID && item.properties && item.properties[GIFT_PROP];
  }

  // Sammelt die auf DIESER Seite vorhandenen Sektionen fuer das Live-Rendering.
  function sectionSpecs() {
    var specs = [];
    if (document.querySelector('cart-drawer')) {
      specs.push({ api: 'cart-drawer', selector: '#CartDrawer', target: '#CartDrawer' });
    }
    var items = document.getElementById('main-cart-items');
    if (items) {
      specs.push({ api: items.dataset.id, selector: '.js-contents', target: '#main-cart-items .js-contents' });
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer) {
      specs.push({ api: footer.dataset.id, selector: '.js-contents', target: '#main-cart-footer .js-contents' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      specs.push({ api: 'cart-icon-bubble', selector: '.shopify-section', target: '#cart-icon-bubble' });
    }
    return specs;
  }

  function applySections(specs, sections) {
    if (!sections) return;
    specs.forEach(function (s) {
      var html = sections[s.api];
      if (html == null) return;
      var target = document.querySelector(s.target);
      if (!target) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  function postCart(url, payload) {
    var specs = sectionSpecs();
    payload.sections = specs.map(function (s) { return s.api; }).join(',');
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { applySections(specs, state.sections); return state; });
  }

  function addGift() {
    var props = {};
    props[GIFT_PROP] = 'true';
    return postCart('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] });
  }

  function setGiftQty(key, qty) {
    return postCart('/cart/change.js', { id: key, quantity: qty });
  }

  function reconcile() {
    if (running) { queued = true; return; }
    running = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLine = null;
        var nonGiftTotal = 0;
        (cart.items || []).forEach(function (item) {
          if (isGiftLine(item)) {
            giftLine = item;
          } else {
            nonGiftTotal += item.final_line_price;
          }
        });

        var qualifies = nonGiftTotal >= THRESHOLD_CENTS;

        if (qualifies && !giftLine) {
          return addGift();
        }
        if (qualifies && giftLine && giftLine.quantity !== 1) {
          return setGiftQty(giftLine.key, 1); // gegen manuelles Hochzaehlen
        }
        if (!qualifies && giftLine) {
          return setGiftQty(giftLine.key, 0);
        }
        return null;
      })
      .catch(function () { /* still: Warenkorb bleibt unveraendert */ })
      .then(function () {
        running = false;
        if (queued) { queued = false; reconcile(); }
      });
  }

  // Auf jede Warenkorb-Aenderung von Dawn reagieren (Add / Qty / Remove).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, reconcile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
